{
  "drawer": {
    "title": "Payout information",
    "toasts": {
      "create": {
        "error": "An error occurred while adding payout information",
        "success": "Payout information added"
      },
      "update": {
        "error": "An error occurred while updating payout information",
        "success": "Payout information updated"
      }
    }
  },
  "addPayoutInfo": {
    "button": "Add my payout information",
    "description": "Add a new payout method for receiving payments"
  },
  "title": "Payout information",
  "toasts": {
    "fetchBeneficiary": {
      "error": "An error occurred while retrieving beneficiary details"
    },
    "fetchPayoutInfo": {
      "error": "An error occurred while retrieving payout information"
    },
    "upsertBeneficiary": {
      "error": "An error occurred while updating payout information",
      "success": "Payout information has been successfully updated"
    }
  }
}